var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Login")]),_c('p',[_vm._v("Um sich einzuloggen, bitte folgenden Link aufrufen:")]),_c('p',[_c('a',{attrs:{"href":_vm.vueAppTokenApiUrl,"title":"Login"}},[_vm._v("FairtriebsChampions")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }